"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faUserCircle_1 = require("@fortawesome/pro-solid-svg-icons/faUserCircle");
var interfaces_1 = require("@hudled/interfaces");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var AccountingFirmInfo_1 = __importDefault(require("containers/Navbar/AccountingFirmInfo"));
var CompanySettings_1 = __importDefault(require("containers/Navbar/CompanySettings"));
var HudledAdminSettings_1 = __importDefault(require("containers/Navbar/HudledAdminSettings"));
var LogoutButton_1 = __importDefault(require("containers/Navbar/LogoutButton"));
var PersonalDetails_1 = __importDefault(require("containers/Navbar/PersonalDetails"));
var PersonalSettings_1 = __importDefault(require("containers/Navbar/PersonalSettings"));
var SettingsIconButton_1 = __importDefault(require("containers/Navbar/styles/SettingsIconButton"));
var Divider_1 = __importDefault(require("shared/components/Divider"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var other_1 = require("utils/selectors/other");
var single_1 = require("utils/selectors/single");
var RecharglySiteMenu = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _a = __read(react_1.default.useState(null), 2), settingsAnchorEl = _a[0], setSettingsAnchorEl = _a[1];
    var handleSettingsClick = function (event) {
        setSettingsAnchorEl(event.currentTarget);
    };
    var handleSettingsClose = function () { setSettingsAnchorEl(null); };
    var canAdmin = (0, react_redux_1.useSelector)((0, other_1.makeSelectUserCan)(interfaces_1.ACCESS_LEVEL.Admin));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SettingsIconButton_1.default, { icon: faUserCircle_1.faUserCircle, "aria-controls": "settings", "aria-haspopup": "true", onClick: handleSettingsClick }), (0, jsx_runtime_1.jsxs)(DropdownMenu_1.default, __assign({ id: "settings", anchorEl: settingsAnchorEl, open: !!settingsAnchorEl, onClose: handleSettingsClose }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { pt: 1 }), (0, jsx_runtime_1.jsx)(PersonalDetails_1.default, {}), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(Box_1.default, { pt: 1 }), (0, jsx_runtime_1.jsx)(PersonalSettings_1.default, { onClick: handleSettingsClose }), (0, jsx_runtime_1.jsx)(Box_1.default, { pb: 1 }), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(Box_1.default, { pt: 1 }), (0, jsx_runtime_1.jsx)(AccountingFirmInfo_1.default, {}), canAdmin && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { pt: 1 }), (0, jsx_runtime_1.jsx)(CompanySettings_1.default, { onClick: handleSettingsClose }), (0, jsx_runtime_1.jsx)(Box_1.default, { pb: 1 }), (0, jsx_runtime_1.jsx)(Divider_1.default, {})] })), (0, jsx_runtime_1.jsx)(LogoutButton_1.default, { onClick: handleSettingsClose }), (profile === null || profile === void 0 ? void 0 : profile.isAdmin) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(Box_1.default, { pt: 1 }), (0, jsx_runtime_1.jsx)(HudledAdminSettings_1.default, { onClick: handleSettingsClose }), (0, jsx_runtime_1.jsx)(Box_1.default, { pb: 1 })] }))] }))] }));
};
exports.default = RecharglySiteMenu;
